import { Chip, IconRefresh } from '@banhala/ui-kit';
import { useNavigation, useRoute } from '@react-navigation/native';
import { useFilterListAtom } from '../Provider/filterList/useFilterListAtom';
import { useFilterListBottomSheetAtom } from '../Provider/filterListBottomSheet/useFilterListBottomSheetAtom';
import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';

type ResetChipProps = {
  closeSearchBar: VoidFunction;
  logging: AnyObject;
};

export const ResetChip = ({ closeSearchBar, logging }: ResetChipProps) => {
  const { clearFilterList } = useFilterListAtom();
  const { clearFilterListBottomSheet } = useFilterListBottomSheetAtom();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();
  const { params } = useRoute();

  const handleResetButton = () => {
    logClickResetChip(logging);
    clearFilterList();
    closeSearchBar();
    clearFilterListBottomSheet();
    // next_token과 screen_name을 제외한 모든 params를 undefined로 설정하여 제거
    const paramsToReset = Object.keys(params ?? {}).reduce(
      (acc, key) => {
        if (key === 'next_token' || key === 'screen_name') {
          // next_token은 유지
          return acc;
        }
        acc[key] = undefined;
        return acc;
      },
      {} as Record<string, undefined>,
    );

    navigation.setParams(paramsToReset);
  };

  return (
    <Chip
      size="medium"
      state={'enabled'}
      rightIcon={<IconRefresh />}
      onPress={handleResetButton}
    >
      초기화
    </Chip>
  );
};

const logClickResetChip = (logging: AnyObject) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_FILTER',
    ably_only_log: logging.analytics.ably_only_log,
    analytics: {
      ...logging.analytics.analytics,
      SELECTED_ITEM: '초기화',
    },
  });
};
